import React from "react";
import type { ContentBlock } from "../../types";
import { FillInBlankBlock } from "./fill-in-blank-block";
import { OrderingBlock } from "./ordering-block";
import { MatchingBlock } from "./matching-block";
import { OrderedResponseBlock } from "./ordered-response-block";

interface InteractiveQuestionBlockProps {
  block: ContentBlock;
  blockIndex: number;
  messageId: string;
  userId: string;
  tabId: string;
  onQuizAnswered?: () => void;
}

export const InteractiveQuestionBlock: React.FC<
  InteractiveQuestionBlockProps
> = ({ block, blockIndex, messageId, userId, tabId, onQuizAnswered }) => {
  switch (block.type) {
    case "fill_in_blank":
      return (
        <FillInBlankBlock
          block={block}
          blockIndex={blockIndex}
          messageId={messageId}
          userId={userId}
          tabId={tabId}
          onQuizAnswered={onQuizAnswered}
        />
      );
    case "ordering":
      return (
        <OrderingBlock
          block={block}
          blockIndex={blockIndex}
          messageId={messageId}
          userId={userId}
          tabId={tabId}
          onQuizAnswered={onQuizAnswered}
        />
      );
    case "matching":
      return (
        <MatchingBlock
          block={block}
          blockIndex={blockIndex}
          messageId={messageId}
          userId={userId}
          tabId={tabId}
          onQuizAnswered={onQuizAnswered}
        />
      );
    case "ordered_response":
      return (
        <OrderedResponseBlock
          block={block}
          blockIndex={blockIndex}
          messageId={messageId}
          userId={userId}
          tabId={tabId}
          onQuizAnswered={onQuizAnswered}
        />
      );
    default:
      return null;
  }
};
